<template>
  <footer class="worldmc-footer">
    <div class="footer-inner">
      <p class="footer-title">
        ICOMIA WORLD MARINAS CONFERENCE 2027<br />SHANGHAI, CHINA
      </p>
      <div class="footer-links">
        <p class="footer-nav">
          <button type="button" @click="goTransfers">
            {{ t("shell.worldmc.footer.delegateSupport") }}
          </button>
          <span>•</span>
          <button type="button" @click="goVisa">
            {{ t("shell.worldmc.footer.privacy") }}
          </button>
          <span>•</span>
          <button type="button" @click="goVisa">
            {{ t("shell.worldmc.footer.terms") }}
          </button>
        </p>
        <p class="footer-copy">© {{ year }} ICOMIA World Marinas Conference</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";

const { t } = useI18n();
const router = useRouter();
const year = new Date().getFullYear();
const channelStore = useYChannelStoreHook();

const navigate = path => {
  router.push({
    path,
    query: { channel: channelStore.channel || "worldmc" }
  });
};
const goTransfers = () => navigate("/airport-transfers");
const goVisa = () => navigate("/visa-information");
</script>

<style lang="scss" scoped>
/* 设计口径：深藏蓝 #021E3C，左会议名右链接，与 WorldmcShell Footer 同源 */
.worldmc-footer {
  width: 100%;
  margin-top: auto;
  background: #021e3c;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 154px;
  padding: 24px 72px;
}

.footer-title {
  margin: 0;
  color: #fff;
  font-family: "lato", sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.45;
}

.footer-links {
  color: #a8bfcf;
  font-family: "lato", sans-serif;
  font-size: 13px;
  text-align: right;
}

.footer-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 0 8px;
}

.footer-nav button {
  padding: 0;
  border: 0;
  color: #a8bfcf;
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.footer-nav button:hover {
  color: #fff;
}

.footer-copy {
  margin: 0;
}

@media screen and (max-width: 1280px) {
  .footer-inner {
    padding: 24px 36px;
  }
}

/* 移动布局（D-25）：会议名与链接区上下堆叠、左对齐 */
@media screen and (max-width: 768px) {
  .footer-inner {
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
    min-height: 0;
    padding: 28px 24px;
  }

  .footer-title {
    font-size: 13px;
  }

  .footer-links {
    text-align: left;
  }

  .footer-nav {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>
